<sim-basic-app-page-layout headerIcon="fa-sign" headerLabel="PAGE_TITLE_DIGITAL_SIGNAGE" [isLoading]="false">
	<div body class="gridLayout">
		<!--LEFT-->
		<section class="left">
			<label class="mat-headline-5">{{ T.DIGITAL_SIGNAGE_CONFIG_HEADER | translate }}</label>
			<mat-tab-group [mat-stretch-tabs]="false" color="accent">
				@for (trainingRoomGroup of trainingRoomsGrouped; track trainingRoomGroup.id) {
					<mat-tab [label]="trainingRoomGroup.name">
						<div class="scrollViewport">
							<mat-accordion>
								@for (trainingRoom of trainingRoomGroup.trainingRooms; track trainingRoom.id) {
									<mat-expansion-panel>
										<mat-expansion-panel-header>
											{{ trainingRoom?.name }}
										</mat-expansion-panel-header>
										<ng-template matExpansionPanelContent>
											<div class="players">
												@for (
													digitalSignagePlayer of trainingRoom?.digitalSignagePlayers;
													track digitalSignagePlayer.id
												) {
													<div [class.playerBusy]="playerBusy.has(digitalSignagePlayer.id)" class="player">
														<div class="playerHeader">
															<div class="playerName">
																{{ digitalSignagePlayer.name }}
															</div>
															<div class="playerActions">
																@if (
																	digitalSignagePlayer?.webSocket?.activityState === ActivityState.Active
																) {
																	<button
																		(click)="reloadPlayer(digitalSignagePlayer)"
																		[matTooltip]="T.DIGITAL_SIGNAGE_RELOAD_PLAYER | translate"
																		color="accent"
																		mat-icon-button
																		matTooltipClass="accent"
																	>
																		<mat-icon
																			fontIcon="fa-redo"
																			fontSet="fad"
																			inline
																			style="font-size: 1.5em"
																		/>
																	</button>
																}

																@if (_simWakeOnLanService.canShutDown(digitalSignagePlayer)) {
																	<button
																		(click)="
																			_simWakeOnLanService.shutDownMappedDevice(digitalSignagePlayer)
																		"
																		[matTooltip]="T.DIGITAL_SIGNAGE_SHUTDOWN_PLAYER | translate"
																		color="accent"
																		mat-icon-button
																		matTooltipClass="warn"
																		style="color: red"
																	>
																		<mat-icon
																			fontIcon="fa-power-off"
																			fontSet="fad"
																			inline
																			style="font-size: 1.5em"
																		/>
																	</button>
																}

																@if (_simWakeOnLanService.canWakeUp(digitalSignagePlayer)) {
																	<button
																		(click)="
																			_simWakeOnLanService.wakeUpMappedDevice(digitalSignagePlayer)
																		"
																		[matTooltip]="T.DIGITAL_SIGNAGE_START_PLAYER | translate"
																		color="accent"
																		mat-icon-button
																		matTooltipClass="accent"
																	>
																		<mat-icon
																			fontIcon="fa-power-off"
																			fontSet="fad"
																			inline
																			style="font-size: 1.5em"
																		/>
																	</button>
																}

																<mat-divider [vertical]="true" />

																<i
																	[class.offline]="
																		digitalSignagePlayer.webSocket?.activityState ===
																		ActivityState.Inactive
																	"
																	[matTooltipClass]="
																		digitalSignagePlayer.webSocket?.activityState
																			? digitalSignagePlayer.webSocket?.activityState ===
																				ActivityState.Active
																				? 'accent'
																				: 'warn'
																			: 'warn'
																	"
																	[matTooltip]="
																		digitalSignagePlayer.webSocket?.activityState
																			? ActivityState[digitalSignagePlayer.webSocket?.activityState]
																			: ActivityState[ActivityState.Inactive]
																	"
																	class="fad fa-circle"
																></i>
															</div>
														</div>

														@if (playerBusy.has(digitalSignagePlayer.id)) {
															<div class="contentToShow aspectRatio169">
																<div class="playerBusyIndication">
																	<i class="fa-spin fad fa-spinner-third fa-4x accent"></i>
																	@if (playerBusy.get(digitalSignagePlayer.id).restart) {
																		<i class="fad fa-redo accent playerBusyIndicationLoadingIcon"></i>
																	}
																</div>
															</div>
														}

														@if (!playerBusy.has(digitalSignagePlayer.id)) {
															<div
																(cdkDropListDropped)="elementDropped($event, digitalSignagePlayer)"
																[id]="
																	'dropListRoomId-' +
																	trainingRoom?.id +
																	'PlayerId-' +
																	digitalSignagePlayer.id
																"
																cdkDropList
																class="contentToShow aspectRatio169"
															>
																@if (
																	!digitalSignagePlayer.signage?.mode ||
																	digitalSignagePlayer.signage.mode === SignageMode.Default
																) {
																	<div class="digitalSignageNotConfigured">
																		<div class="text">
																			{{ T.DIGITAL_SIGNAGE_CONFIG_NOT_CONFIGURED | translate }}
																		</div>
																		<div class="icon">
																			<i class="fad fa-sign fa-3x"></i>
																		</div>
																	</div>
																}

																@if (digitalSignagePlayer?.signage) {
																	<div class="removeSignage">
																		<button
																			(click)="removeSignage(digitalSignagePlayer)"
																			color="warn"
																			mat-mini-fab
																		>
																			<mat-icon
																				fontIcon="fa-times"
																				fontSet="fas"
																				inline
																				style="font-size: 1.5em"
																			/>
																		</button>
																	</div>
																}

																@if (digitalSignagePlayer.signage) {
																	@switch (digitalSignagePlayer.signage.mode) {
																		@case (SignageMode.Media) {
																			@if (digitalSignagePlayer.signage.mediaId) {
																				<div class="mediaHolderForContent">
																					<sim-media-viewer
																						(mediaLoaded)="mediaLoaded(digitalSignagePlayer)"
																						[autoSize]="true"
																						[displayedMediaId]="
																							digitalSignagePlayer.signage.mediaId
																						"
																					/>
																					@if (playerMediaLoading.has(digitalSignagePlayer.id)) {
																						<div class="loadingMediaContent">
																							<i
																								class="fa-spin fad fa-spinner-third fa-4x accent"
																							></i>
																							<i class="fad fa-photo-video accent"> </i>
																						</div>
																					}
																				</div>
																			}
																		}
																		@case (SignageMode.TrainingRoom) {
																			<ng-container
																				*ngVar="
																					digitalSignagePlayer.signage.trainingRoomId
																						| getTrainingRoomById
																						| async as trainingRoom
																				"
																			>
																				@if (digitalSignagePlayer.signage.trainingRoomId) {
																					<div class="mediaHolderForContent">
																						<ng-container>
																							<img
																								[src]="
																									_simTrainingRoomService.getTrainingRoomThumbnail_Url(
																										digitalSignagePlayer.signage
																											?.trainingRoomId,
																										digitalSignagePlayer.signage
																											?.roomLayoutPreset
																									)
																								"
																								alt=""
																								class="trainingRoomThumbnailImg"
																								width="100%"
																							/>
																						</ng-container>
																						<div class="roomLayoutPresetSwitcher">
																							@for (
																								_ of [].constructor(4);
																								track _;
																								let iRoomLayout = $index
																							) {
																								<div
																									(click)="
																										changeRoomLayout(
																											digitalSignagePlayer,
																											iRoomLayout
																										)
																									"
																									[class.active]="
																										digitalSignagePlayer?.signage
																											?.roomLayoutPreset ===
																										iRoomLayout
																									"
																									[class.disabled]="
																										!trainingRoom?.roomLayout?.[
																											iRoomLayout
																										]
																									"
																									class="roomLayoutSwitchButton"
																									mat-ripple
																								>
																									{{ iRoomLayout + 1 }}
																								</div>
																							}
																						</div>
																						<div class="loadingMediaContent">
																							<i
																								class="fa-spin fad fa-spinner-third fa-4x accent"
																							></i>
																							<i class="fad fa-door-open accent"> </i>
																						</div>
																					</div>
																				}
																			</ng-container>
																		}
																	}
																}
															</div>
														}
													</div>
												}
											</div>
										</ng-template>
									</mat-expansion-panel>
								}
							</mat-accordion>
						</div>
					</mat-tab>
				}
			</mat-tab-group>
		</section>
		<!--RIGHT-->
		<section class="right">
			<label class="mat-headline-5">{{ T.DIGITAL_SIGNAGE_SOURCES_HEADING | translate }}</label>
			<mat-tab-group [mat-stretch-tabs]="false" color="accent">
				<mat-tab [label]="T.DIGITAL_SIGNAGE_MEDIA_HEADING | translate">
					<mat-tab-group
						[(selectedIndex)]="selectedTabIndex"
						[mat-stretch-tabs]="false"
						class="h-100 mediaHolderTabGroup"
						color="accent"
					>
						@for (mediaType of mediaTypes; track mediaType) {
							<mat-tab [label]="MediaType[mediaType]">
								<ng-template matTabContent>
									@if (availableData && !loadingAvailableData) {
										<div
											class="scrollViewport availableVogMediasContainer"
											cdkDropList
											(cdkDropListDropped)="test()"
											(scroll)="mediaHolderScrolled($event, mediaType)"
											[@zoomInOnEnter]
											style="height: 100%"
											[id]="'availableMedias' + mediaType"
											[cdkDropListSortingDisabled]="true"
											[cdkDropListConnectedTo]="allPlayerDropLists()"
										>
											@if (!availableData[mediaType] || availableData[mediaType].length === 0) {
												<div class="noMediaForThisType">
													@switch (mediaType) {
														@case (MediaType.Audio) {
															<i class="fad fa-3x fa-volume-up"></i>
														}
														@case (MediaType.PDF) {
															<i class="fad fa-3x fa-file-pdf"></i>
														}
														@case (MediaType.Excel) {
															<i class="fad fa-3x fa-file-excel"></i>
														}
														@case (MediaType.Image) {
															<i class="fad fa-3x fa-image-polaroid"></i>
														}
														@case (MediaType.PowerPoint) {
															<i class="fad fa-3x fa-file-powerpoint"></i>
														}
														@case (MediaType.Video) {
															<i class="fad fa-3x fa-file-video"></i>
														}
														@default {
															<i class="fad fa-3x fa-edit"></i>
														}
													}
													{{ T.SHARED_BASIC_ADMINISTRATION_NO_MEDIA_FOUND | translate }}
												</div>
											}

											<div class="withoutVirtualContainer">
												@for (media of asMedias(availableData[mediaType]); track media.id) {
													<div
														class="sound-card"
														cdkDrag
														[cdkDragData]="{
															item: media,
															index: $index,
															type: DraggedItemType.Media,
														}"
													>
														<sim-media-card-list [media]="media" />
													</div>
												}
											</div>

											@if (!currentPagesPerMediaType.get(mediaType).end) {
												<div class="loadingNextPage">
													<i class="fa-spin fad fa-spinner-third fa-4x accent"></i>
													@switch (mediaType) {
														@case (MediaType.Image) {
															<i class="fad fa-file-image accent innerLoadingIcon"></i>
														}
														@case (MediaType.Video) {
															<i class="fad fa-file-video accent innerLoadingIcon"></i>
														}
														@case (MediaType.PowerPoint) {
															<i class="fad fa-file-powerpoint accent innerLoadingIcon"></i>
														}
														@case (MediaType.Audio) {
															<i class="fad fa-file-audio accent innerLoadingIcon"></i>
														}
														@case (MediaType.PDF) {
															<i class="fad fa-file-pdf accent innerLoadingIcon"></i>
														}
													}
												</div>
											}
										</div>
									}
								</ng-template>
							</mat-tab>
						}
					</mat-tab-group>
				</mat-tab>

				<mat-tab [label]="T.DIGITAL_SIGNAGE_ROOM_HEADING | translate">
					<ng-template matTabContent>
						<sim-training-room-navigation-panel
							[connectedLists]="allPlayerDropLists()"
							[disableSelection]="true"
							[enableDraggingRooms]="true"
							[roomCapability]="RoomCapability.Training"
							[trainingRoomWhitelist]="null"
						/>
					</ng-template>
				</mat-tab>
			</mat-tab-group>
		</section>
	</div>
</sim-basic-app-page-layout>
